export const warranty_status_list = [
    { label: "In Warranty", value: "IN_WARRANTY" },
    { label: "Expiring Soon", value: "EXPIRING_SOON" },
    { label: "Expired", value: "EXPIRED" },
];

export const product_category_list = [
    { "label": "Electronics", "value": "ELECTRONICS" },
    { "label": "Home Appliances", "value": "HOME_APPLIANCES" },
    { "label": "Furniture", "value": "FURNITURE" },
    { "label": "Fashion & Apparel", "value": "FASHION_APPAREL" },
    { "label": "Health & Beauty", "value": "HEALTH_BEAUTY" },
    { "label": "Sports & Outdoors", "value": "SPORTS_OUTDOORS" },
    { "label": "Toys & Games", "value": "TOYS_GAMES" },
    { "label": "Automotive", "value": "AUTOMOTIVE" },
    { "label": "Books & Stationery", "value": "BOOKS_STATIONERY" },
    { "label": "Pet Supplies", "value": "PET_SUPPLIES" },
    { "label": "Jewelry & Watches", "value": "JEWELRY_WATCHES" },
    { "label": "Technology & Gadgets", "value": "TECHNOLOGY_GADGETS" },
    { "label": "Green & Sustainable Products", "value": "GREEN_SUSTAINABLE_PRODUCTS" },
    { "label": "Luxury & Premium Products", "value": "LUXURY_PREMIUM_PRODUCTS" }
]

export const complaint_priorities_list = [
    { "label": "Low", "value": "LOW" },
    { "label": "Medium", "value": "MEDIUM" },
    { "label": "High", "value": "HIGH" },
]

export const complaint_type_list = [
    { "label": "New", "value": "NEW" },
    { "label": "Late Delivery", "value": "LATE_DELIVERY" },
    { "label": "Damaged Item", "value": "DAMAGED_ITEM" },
    { "label": "Wrong Item Received", "value": "WRONG_ITEM_RECEIVED" },
    { "label": "Customer Service", "value": "CUSTOMER_SERVICE" },
    { "label": "Refund Issue", "value": "REFUND_ISSUE" },
    { "label": "Technical Issue", "value": "TECHNICAL_ISSUE" },
    { "label": "Packaging Issue", "value": "PACKAGING_ISSUE" },
    { "label": "Order Cancellation", "value": "ORDER_CANCELLATION" },
    { "label": "Billing Issue", "value": "BILLING_ISSUE" },
    { "label": "Shipping Issue", "value": "SHIPPING_ISSUE" },
    { "label": "Other", "value": "OTHER" }
]

